import React, { PropTypes } from 'react';
import axios from './../../../../constants/axios';
import { Table } from 'react-bootstrap';

class FixedAssetInvoiceDetailItem extends React.Component {
   constructor(props) {
      super(props);
      this.state = {
         invoiceItems: []
      };
   }

   componentDidMount() {
      const { invoiceId } = this.props.params;
      axios.get(`fixedAssets/getItemsByInvoiceId/${invoiceId}`)
         .then((res) => {
            this.setState({
               invoiceItems: res.data
            });
         });
   }

   render() {
      const { invoiceItems } = this.state;
      return (
         <div>
            <h4>Invoice Items</h4>
            <Table>
               <thead>
               <tr>
                  <th>Asset Id</th>
                  <th>Asset Name</th>
                  <th>Initial Value</th>
                  <th>Salvage Value</th>
               </tr>
               </thead>
               <tbody>
               {invoiceItems.map((item) => (
                  <tr key={item.asset_id} >
                     <td>{item.asset_id}</td>
                     <td>{item.name}</td>
                     <td>{item.initial_value}</td>
                     <td>{item.salvage_value}</td>
                  </tr>
               ))}
               </tbody>
            </Table>
         </div>
      );
   }
}

FixedAssetInvoiceDetailItem.propTypes = {
   params: PropTypes.object
};

export default FixedAssetInvoiceDetailItem;



/** WEBPACK FOOTER **
 ** ./src/components/InvoiceManagement/FixedAsset/FixedAssetInvoiceDetail/FixedAssetInvoiceDetailItem.js
 **/